import { useState } from "react";
import {
  API,
  deleteCall,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../../config";
import MainBody from "../../../../components/MainBody/MainBody";
import BootstrapTable from "react-bootstrap-table-next";
import { ResponsiveDrawerForm } from "../../../../components/ResponsiveDrawerForm";
import { LucidePlusCircle } from "lucide-react";
import AddEditTraining from "./AddEditTraining";
import TrainingActionButton from "./TrainingActionButton";
import Confirmation from "../../../../components/Confirmation";
import { AnimatedTooltip } from "../../../../components/AnimatedTooltip";

const Assessments = ({
  expandList = false,
  trainingData,
  trainingList,
  fetchTrainings,
  limit,
  page,
}) => {
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const [trainingId, setTrainingId] = useState(null);
  const [showAddEditTraining, setShowAddEditTraining] = useState(false);
  const [showTrainingDelete, setShowTrainingDelete] = useState(false);

  const toggleShowDelete = () => {
    if (showTrainingDelete) {
      setTrainingId(null);
    }
    setShowTrainingDelete(!showTrainingDelete);
  };

  const toggleShowAddEditTraining = () => {
    if (showAddEditTraining) {
      setEdit(false);
      setEditItem(null);
      setTrainingId(null);
    }
    setShowAddEditTraining(!showAddEditTraining);
  };

  const trainingsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: trainingList[i]?.id,
        id: trainingList[i]?.id,
        organization_type: (
          <AnimatedTooltip
            leftAlign={false}
            title={
              <ul>
                {trainingList[i]?.organization_types
                  ?.filter((item) => item?.name)
                  .map((item, index) => (
                    <li key={index}>{item.name}</li>
                  ))}
              </ul>
            }
          >
            <span>
              {trainingList[i]?.organization_types?.length} Industry Types
            </span>
          </AnimatedTooltip>
        ),
        title: trainingList[i]?.title ? trainingList[i]?.title : "",
        description: trainingList[i]?.description
          ? trainingList[i]?.description
          : "",
        action: (
          <>
            <TrainingActionButton
              id={trainingList[i]?.id}
              setEdit={setEdit}
              assessment={true}
              setTrainingId={setTrainingId}
              toggleShowAddEditTraining={toggleShowAddEditTraining}
              toggleShowDelete={toggleShowDelete}
            />
          </>
        ),
      });
    }
    return items;
  };

  const trainings = trainingsGenerator(trainingList?.length);

  const columns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "organization_type",
      text: "Industry Type",
    },

    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "title",
      text: "Title",
    },
    {
      headerClasses: `${THClasses} !whitespace-normal`,
      classes: `${TDClasses} !whitespace-normal`,
      dataField: "description",
      text: "Description",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "127px" },
    },
  ];

  // Single Training Delete
  const handleTrainingDelete = async () => {
    try {
      setLoading(true);
      await deleteCall(`${API.ADMIN_TRAINING_DELETE}/${trainingId}`);
      setLoading(false);
      fetchTrainings();
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <MainBody
        search={false}
        actionRight={true}
        actionContent={
          !expandList && (
            <div className="flex items-center gap-3 flex-wrap">
              {/* Add Training */}
              <ResponsiveDrawerForm
                description={""}
                title={edit ? "Edit Assessment" : "Add Assessment"}
                handleOpen={() => {}}
                handleClose={() => {
                  setEdit(false);
                  setTrainingId();
                  setEditItem(null);
                }}
                buttonText={
                  <div className="flex items-center gap-1">
                    <LucidePlusCircle size={18} />
                    <span>Add Assessment</span>
                  </div>
                }
                open={showAddEditTraining}
                buttonClassName={""}
                setOpen={setShowAddEditTraining}
                mobileCancelHidden={true}
                className={"sm:max-w-5xl"}
              >
                <AddEditTraining
                  edit={edit}
                  editItem={editItem}
                  assessment={true}
                  toggleShowAddEditTraining={toggleShowAddEditTraining}
                  id={trainingId}
                  fetchTrainingData={() => fetchTrainings(limit, page)}
                />
              </ResponsiveDrawerForm>
            </div>
          )
        }
        loading={loading}
        innerBody={true}
        expandList={true}
        mainClassName="w-[calc(100%-3rem)]"
      >
        <div className="custom-table">
          <div className="table-body-class max-h-[590px]">
            <BootstrapTable
              keyField="key"
              remote
              data={trainings}
              columns={columns}
              rowClasses={TRClasses}
              noDataIndication="No Data Found"
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>

          <Confirmation
            title={"Delete Training"}
            open={showTrainingDelete}
            setOpen={setShowTrainingDelete}
            toggleShow={() => {
              toggleShowDelete();
            }}
            className="sm:max-w-1/2"
            message={"Are you sure you want to delete training?"}
            okAction={async () => {
              handleTrainingDelete();
              toggleShowDelete();
              fetchTrainings();
            }}
            cancelAction={() => {
              setTrainingId(null);
              setShowTrainingDelete(!showTrainingDelete);
            }}
          />
        </div>
      </MainBody>
    </>
  );
};

export default Assessments;
